import React from 'react';
import {FormattedMessage} from 'react-intl';
import Container from '../common/index';
import {SubWrapper, Title, Description} from './styles';
const Header = () => (
  <SubWrapper>
    <Container>
      <Title>
        <FormattedMessage id="barmej_subscriptions" />
      </Title>
      <Description>
        <FormattedMessage id="barmej_subscriptions_description_1" />
        <span>
          <FormattedMessage id="barmej_supscriptions_description_2" />
        </span>
      </Description>
    </Container>
  </SubWrapper>
);

export default Header;
